const KEYCLOAK_TRANSIENT_PARAMS = [
  'error',
  'error_description',
  'state',
  'session_state',
  'iss',
];

export const cleanLoginRequiredCallbackFromUrl = () => {
  if (typeof window === 'undefined') return;

  const url = new URL(window.location.href);
  if (url.searchParams.get('error') !== 'login_required') return;

  KEYCLOAK_TRANSIENT_PARAMS.forEach(param => {
    url.searchParams.delete(param);
  });

  const cleanUrl = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState(window.history.state, '', cleanUrl);
};
